export enum Type {
  MANAGER = 'webUser',
  EMPLOYEE = 'ee',
}

export interface Account {
  accountId: string;
  accountName: string;
}

export interface Hotel {
  entId: string;
  entName: string;
}

export interface User {
  name: {
    first: string;
    last: string;
  };
  userName: string;
  emailAddress: string;
  jobTitle: string;
  activeInd: boolean;
  roleId: number;
  pin: number;
  question1: string;
  question2: string;
  question3: string;
  answer1: string;
  answer2: string;
  answer3: string;
  startDate: string | null;
  periodType: number;
  tzid: number;
  phone: string;
  phoneMobile: string;
  userTypeId: string;
  userType: string;
  isLocked: number;
  resendInvitation: number;
  userkey: string;
  createWebUserId: number;
  createdOn: string;
  modifiedWebUserId: number;
  modifiedOn: string;
  tzName: string;
  workWeekPreference: string;
  canSeeWages: boolean;
  hasDepartmentFilters: boolean;
  deptFilterList: Array<DepartmentFilter>;
  hotelCount: number;
  hotelLkup: string | null;
  userStatus: number | null;
  resendInvDesc: number | null;
  fullName: string | null;
  inviteStatus: number | null;
  operative: boolean | null;
  WebUserId: string;
  accounts: Account[];
  hotels: Hotel[];
  allHotels: Hotel[];
  isInsider: number;
  workWeekStartDate: string;
  workWeekEndDate: string;
  hotelSuspensionList: string[];
  hotelSuspensionStatus: string;
}

export interface DepartmentFilter {
  stdposcd: string;
  entList: Array<number>;
}

export interface NotificationPreferences {
  chatPush: boolean;
  announcementPush: boolean;
  taskAssignedPush: boolean;
  taskDeletedOrUnassignedPush: boolean;
  pendingShiftRequestCountPush: boolean;
}
